import React, { useState } from "react";
import ExploreJobs from "../components/Carrer/ExploreJobs";

import Aside from "../modules/SideNav/Aside";

function ExploreJobLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <ExploreJobs handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default ExploreJobLayout;
